import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/endOfDay/index.js';

var require$$45 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$45 as default };
